import { useEffect, useState } from "react";

export const usePinDrawerStep = <TStep extends string>(
	open: boolean,
	initialStep: TStep,
) => {
	const [step, setStep] = useState<TStep>(initialStep);

	useEffect(() => {
		if (open) {
			setStep(initialStep);
		}
	}, [open, initialStep]);

	return { step, setStep };
};
